import React, { useState } from 'react';
import type { RefObject } from 'react';
import classnames from 'classnames';
import type { CurrencyType } from 'src/utils/stringUtils';
import { useSwipePopup } from 'src/hooks/useSwipePopup';
import HotelCard from '../../../../Hotels/components/HotelCard';

import styles from './hotelPopup.module.css';

interface HotelPopupProps {
  isMobile: boolean;
  popupData?: any; // типизировать после типизации стора hotels
  popupRef: RefObject<HTMLDivElement>;
  isExpandable: boolean;
  isExpanded: boolean;
  isHotelOnly: boolean;
  currencyCode: CurrencyType;
  activateCashbackForPartner: boolean;
  onClosePopup: () => void;
  cashbackLabel?: string;
  cashbackIconWebp?: string;
  cashbackIconPng?: string;
  cashbackTooltipText?: string;
  labelColor: string;
  textColor: string;
}

type AnimationState = 'opening' | 'closing';

const HotelPopup = (props: HotelPopupProps) => {
  const {
    isMobile,
    popupData,
    popupRef,
    isExpandable,
    isExpanded,
    isHotelOnly,
    activateCashbackForPartner,
    onClosePopup,
    currencyCode,
    cashbackLabel,
    cashbackIconWebp,
    cashbackIconPng,
    cashbackTooltipText,
    labelColor,
    textColor,
  } = props;

  const [animation, setAnimation] = useState<AnimationState>('opening');

  const onClose = () => {
    setTimeout(() => {
      onClosePopup();
      resetPopup();
      setAnimation('opening');
    }, 300);

    setAnimation('closing');
  };

  const { delta, resetPopup } = useSwipePopup({
    ref: popupRef,
    onSwipe: onClose,
  });

  if (!popupData && animation !== 'closing') return null;

  return (
    <div
      className={classnames({
        [styles.popupWrapper]: !isMobile,
        [styles.mobilePopupWrapper]: isMobile,
        [styles.collapsedPopupWrapper]:
          !isExpanded && isExpandable && !isMobile,
      })}
      ref={popupRef}
      style={{ bottom: -delta }}
    >
      {popupData ? (
        <HotelCard
          {...popupData}
          isMobile={isMobile}
          activateCashbackForPartner={activateCashbackForPartner}
          currencyCode={currencyCode}
          isMapCard
          isExpanded={isExpanded}
          isHotelOnly={isHotelOnly}
          openInCurrentTab={false} // или isWebView
          onClosePopup={onClosePopup}
          cashbackTooltipText={cashbackTooltipText}
          labelColor={labelColor}
          textColor={textColor}
          cashbackIconWebp={cashbackIconWebp}
          cashbackIconPng={cashbackIconPng}
          cashbackLabel={cashbackLabel}
        />
      ) : null}
    </div>
  );
};

export default HotelPopup;
